import { StyleSheet } from "react-native";
const styles = StyleSheet.create({
  container: {
    width: "100%",
    minHeight: 120,
  },
  grid: {
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  emptyText: {
    paddingVertical: 36,
    textAlign: "center",
    color: "#777",
    fontSize: 14,
  },
});

export default styles;
